import React, { useState } from 'react';
import '../templateGeneration/generatedEnsembleMetadata.scss';
import { PreviewGenerationResult } from './previewGenerationResultData';

interface Props {
    ensembleLine: PreviewGenerationResult;
    ensembleCount: number;
    multiColumn: boolean;
    dpsTrimDisplayText: string;
    productName: string;
    onTemplateNameChange: (newName: string) => void;
    onJobItemSelected: (id: string[], isSelected: boolean) => void
}

const PreviewGroupMetadata = ({
    ensembleLine, ensembleCount, multiColumn, dpsTrimDisplayText, productName, onTemplateNameChange, onJobItemSelected,
}: Props): JSX.Element => {
    const { target } = ensembleLine;
    const [isTouched, setIsTouched] = useState(false);
    const isEmpty = !target.templateName?.trim();
    const showError = isTouched && isEmpty;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newValue = e.target.value;

        onTemplateNameChange(newValue);
        if (!newValue.trim() && ensembleLine.uniqueIdentifier) {
            onJobItemSelected([ensembleLine.uniqueIdentifier], false);
        }
    };

    const handleBlur = (): void => {
        setIsTouched(true);
    };

    const firstHalfMetaData = (<>
        <li>
            <span className="additional-info-property">Template Name:</span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <input
                    required
                    type="text"
                    value={target.templateName || ''}
                    className={`template-name-input ${showError ? 'error' : ''}`}
                    placeholder="Enter template name (required)"
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {showError && (
                    <span style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                        Template name is required
                    </span>
                )}
            </div>
        </li>
        <li>
            <span className="additional-info-property">Trim:</span>
            {dpsTrimDisplayText}
        </li>
        <li>
            <span className="additional-info-property">PRD:</span>
            {target.product}
        </li>
        <li>
            <span className="additional-info-property">Product Name:</span>
            {productName}
        </li>
    </>);
    const secondHalfMetaData = (<>
        <li>
            <span className="additional-info-property">Substrate RGB:</span>
            {target.substrateColor}
            <span style={{ backgroundColor: target.substrateColor, border: '1px solid gray', maxHeight: '20px' }}>&emsp;</span>
        </li>
        <li>
            <span className="additional-info-property">Orientation:</span>
            {target.orientation}
        </li>
        <li>
            <span className="additional-info-property">{`Contains: ${ensembleCount} ensembles`}</span>
        </li>
    </>);

    const metaData = (<>
        {multiColumn
            ? (<>
                <div className="ensemble-metadata smallFont">
                    <ul>
                        {firstHalfMetaData}
                    </ul>
                    <ul>
                        {secondHalfMetaData}
                    </ul>
                </div>
            </>)
            : <div className="ensemble-metadata">
                <ul>
                    {firstHalfMetaData}
                    {secondHalfMetaData}
                </ul>
            </div>}
    </>);

    return (<div className="ensemble-metadata-parent">
        {metaData}
    </div>);
};

export default PreviewGroupMetadata;
